import { PRMarinaLayer } from '@sketch-hq/sketch-web-renderer'
import { SketchElementNodeType } from '../types'

type LayerTypeEnumValueName = PRMarinaLayer['type']['constructor']['name']

/**
 * Map the layer type from the enum value of PRMarinaLayer['type'] to the
 * layer type value used internally by the SketchScene.
 */
const layerTypeMap: Record<LayerTypeEnumValueName, SketchElementNodeType> = {
  PRMarinaLayerType_Artboard: 'artboard',
  PRMarinaLayerType_SymbolMaster: 'symbolMaster',
  PRMarinaLayerType_SymbolInstance: 'symbolInstance',
  PRMarinaLayerType_Group: 'group',
  PRMarinaLayerType_Text: 'text',
  PRMarinaLayerType_Rectangle: 'rectangle',
  PRMarinaLayerType_Triangle: 'triangle',
  PRMarinaLayerType_Oval: 'oval',
  PRMarinaLayerType_Polygon: 'polygon',
  PRMarinaLayerType_Star: 'star',
  PRMarinaLayerType_ShapePath: 'shapePath',
  PRMarinaLayerType_ShapeGroup: 'shapeGroup',
  PRMarinaLayerType_Bitmap: 'bitmap',
  PRMarinaLayerType_Hotspot: 'hotspot',
  PRMarinaLayerType_Slice: 'slice',
}

export function getElementTypeFromEmbindEnumValue(
  LayerTypeEnumValueName: LayerTypeEnumValueName
) {
  const layerType = layerTypeMap[LayerTypeEnumValueName]
  if (!layerType) {
    throw new Error(`Unknown layer type: ${LayerTypeEnumValueName}`)
  }

  return layerType
}

export function getElementTypeFromPRMarinaLayer(prMarinaLayer: PRMarinaLayer) {
  return getElementTypeFromEmbindEnumValue(prMarinaLayer.type.constructor.name)
}
